import IconRun from '@apollo/icons/default/IconRun.svg';
import { Button, ButtonProps, IconButton } from '@apollo/orbit';
import React from 'react';

import { ExplorerLink } from '../explorerLink/ExplorerLink';

export interface OpenInExplorerProps extends ButtonProps {
  graphId: string;
  graphVariant: string;
  document: string;
  variables?: string;
  className?: string;
  graphVisibilityType?: 'graph' | 'public';
  size?: 'sm' | 'md' | 'lg';
  iconOnly?: boolean;
  label?: string;
}

export const OpenInExplorer = ({
  graphId,
  graphVariant,
  document,
  variables,
  className,
  graphVisibilityType = 'graph',
  size = 'md',
  iconOnly = false,
  label,
  ...rest
}: OpenInExplorerProps) => {
  const sharedProps = {
    variant: 'primary' as const,
    className,
    size,
    as: ExplorerLink,
    graphId,
    graphVariant,
    document,
    variables,
    graphVisibilityType,
    label,
    ...rest,
  };

  return iconOnly ? (
    <IconButton
      {...sharedProps}
      aria-label="Open in Explorer"
      icon={<IconRun />}
    />
  ) : (
    <Button {...sharedProps}>Open in Explorer</Button>
  );
};
